export const LOADING_KNOWLEDGE_AREAS = "LOADING_KNOWLEDGE_AREAS";
export const SAVE_LOADING_KNOWLEDGE_AREAS = "SAVE_LOADING_KNOWLEDGE_AREAS";
export const GET_KNOWLEDGE_AREAS = "GET_KNOWLEDGE_AREAS";
export const FORM_FAIL = "FORM_FAIL";
export const FORM_FAIL_JSON = "FORM_FAIL_JSON";
export const KNOWLEDGE_AREAS_FAIL = "KNOWLEDGE_AREAS_FAIL";
export const LOADING_KNOWLEDGE_AREAS_BY_ID = "LOADING_KNOWLEDGE_AREAS_BY_ID";
export const GET_KNOWLEDGE_AREAS_BY_ID = "GET_KNOWLEDGE_AREAS_BY_ID";

